export const configuracionRoutes = [
  {
    path: '/configuracion',
    name: 'Configuracion',
    component: () =>
      import(
        /* webpackChunkName: "sistema" */ '@/modules/Core/views/Index.vue'
      ),
    icon: 'Cog6ToothIcon',
    menu: true,
    desplegable: true,
    meta: {
      title: 'Configuraciones',
      requiresSession: true,
      perfiles: ['SUPERADMIN'],
      permiso: []
    },
    children: [
      {
        path: '/paquetes',
        name: 'Paquetes',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Paquetes/PaquetesIndex.vue'
          ),
        icon: 'mdiPackageVariantClosed',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Paquetes',
          requiresSession: true,
          permiso: [],
          perfiles: ['SUPERADMIN'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/respositorios/',
        name: 'RepositoriosIndex',
        component: () =>
          import(
            /* webpackChunkName: "respositorios" */ '@/modules/Respositorios/views/RespositoriosIndex.vue'
          ),
        icon: 'mdiFolderPlay',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Administrar Recursos',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/licencias',
        name: 'LicenciasSistema',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Licencia/LicenciaIndex.vue'
          ),
        icon: 'mdiKeyChainVariant',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Licencias',
          requiresSession: true,
          permiso: [],
          perfiles: ['SUPERADMIN'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/entidades/solicitudes',
        name: 'EntidadesSolicitudesSistema',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Entidades/EntidadesSolicitudIndex.vue'
          ),
        icon: 'mdiOfficeBuildingPlus',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Entidades solicitudes',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/entidades',
        name: 'EntidadesSistema',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Entidades/EntidadesIndex.vue'
          ),
        icon: 'mdiOfficeBuildingCog',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Entidades',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/contenido-publicitario',
        name: 'ContenidoPublicitario',
        component: () =>
          import('@/modules/Configuracion/views/Pantalla/ContenidoPublicitarioIndex.vue'),
        icon: 'mdiTelevisionPlay',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Contenido publicitario',
          subTitle: 'Videos y mensajes de la pantalla de sala de espera',
          requiresSession: true,
          permiso: [],
          perfiles: ['SUPERADMIN'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/planes',
        name: 'PlanesIndex',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Planes/PlanesIndex.vue'
          ),
        icon: 'mdiLayersOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Planes',
          requiresSession: true,
          permiso: [],
          perfiles: ['SUPERADMIN'],
          showBackButton: false
        },
        children: []
      },

      {
        path: '/funciones',
        name: 'Funciones',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Funciones/FuncionesIndex.vue'
          ),
        typeIcon: 'mdi',
        icon: 'mdiScriptTextOutline',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Funciones',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },

      {
        path: '/headeramin',
        name: 'Header-admin',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/HeaderPdf/HeaderIndex.vue'
          ),
        icon: 'mdiAccountFileOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Cabeceras y Notas de pdf',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/captacion',
        name: 'Captacion',
        component: () =>
          import(
            /* webpackChunkName: "configuracion" */ '@/modules/Configuracion/views/Captacion/CaptacionIndex.vue'
          ),
        icon: 'mdiAccountHeartOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Captación',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/documentos',
        name: 'Documentos',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Documentos/DocumentosIndex.vue'
          ),
        icon: 'mdiFileDocumentMultipleOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Documentos',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/documentos/create',
        name: 'DocumentosCreate',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Documentos/DocumentosForm.vue'
          ),
        icon: 'BookOpenIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Registrar documento',
          requiresSession: true,
          permiso: [],
          perfiles: []
        },
        children: []
      },
      {
        path: '/documentos/create/:id',
        name: 'DocumentosUpdate',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Documentos/DocumentosForm.vue'
          ),
        icon: 'BookOpenIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Actualizar documento',
          requiresSession: true,
          permiso: [],
          perfiles: []
        },
        children: []
      },
      {
        path: '/documentos/comun/create',
        name: 'DocumentosComunCreate',
        component: () => import('@/modules/Configuracion/views/Documentos/DocumentosForm.vue'),
        menu: false,
        meta: { title: 'Registrar documento común', requiresSession: true, permiso: [], perfiles: ['SUPERADMIN'] },
        children: []
      },
      {
        path: '/documentos/comun/create/:id',
        name: 'DocumentosComunUpdate',
        component: () => import('@/modules/Configuracion/views/Documentos/DocumentosForm.vue'),
        menu: false,
        meta: { title: 'Actualizar documento común', requiresSession: true, permiso: [], perfiles: ['SUPERADMIN'] },
        children: []
      },
      {
        path: '/formularios',
        name: 'Formularios',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Formularios/FormsIndex.vue'
          ),
        icon: 'BookOpenIcon',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Formularios',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/formularios/create',
        name: 'FormulariosCreate',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Formularios/FormsForm.vue'
          ),
        icon: 'BookOpenIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Registrar formulario',
          requiresSession: true,
          permiso: [],
          perfiles: []
        },
        children: []
      },
      {
        path: '/formularios/create/:id',
        name: 'FormulariosUpdate',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Formularios/FormsForm.vue'
          ),
        icon: 'BookOpenIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Actualizar formulario',
          requiresSession: true,
          permiso: [],
          perfiles: []
        },
        children: []
      },
      {
        path: '/componentes',
        name: 'Componentes',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/ComponentsForm/CompsFormsIndex.vue'
          ),
        icon: 'mdiToyBrick',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Componentes Form.',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/components/create',
        name: 'ComponentesCreate',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/ComponentsForm/CompsFormsForm.vue'
          ),
        icon: 'BookOpenIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Registrar componente',
          requiresSession: true,
          permiso: [],
          perfiles: []
        },
        children: []
      },
      {
        path: '/components/create/:id',
        name: 'ComponentesUpdate',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/ComponentsForm/CompsFormsForm.vue'
          ),
        icon: 'BookOpenIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Actualizar componente',
          requiresSession: true,
          permiso: [],
          perfiles: []
        },
        children: []
      },
      {
        path: '/sistema',
        name: 'ConfiguracionSistema',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/ConfiguracionIndex.vue'
          ),
        icon: 'mdiCog',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Configuracion',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/usuarios',
        name: 'Usuarios',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Autenticacion/Usuarios/UsuariosIndex.vue'
          ),
        icon: 'UsersIcon',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Usuarios',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/usuarios/perfil/:id',
        name: 'UsuariosPerfil',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Autenticacion/Usuarios/ProfileUser.vue'
          ),
        icon: 'BriefcaseIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Perfil usuario',
          requiresSession: true,
          permiso: []
        },
        children: []
      },
      {
        path: '/usuarios/create',
        name: 'UsuariosCreate',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Autenticacion/Usuarios/UsuariosForm.vue'
          ),
        icon: 'BriefcaseIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Registrar usuario',
          requiresSession: true,
          permiso: []
        },
        children: []
      },
      {
        path: '/usuarios/create/:id',
        name: 'UsuariosUpdate',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Autenticacion/Usuarios/UsuariosForm.vue'
          ),
        icon: 'BriefcaseIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Actualizar usuario',
          requiresSession: true,
          permiso: []
        },
        children: []
      },
      {
        path: '/perfiles',
        name: 'Perfiles',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Autenticacion/Perfiles/ProfileIndex.vue'
          ),
        icon: 'mdiBadgeAccount',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Perfiles',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/papelera',
        name: 'Papelera',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Configuracion/views/Papelera/PapeleraIndex.vue'
          ),
        icon: 'TrashIcon',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Papelera',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/logs',
        name: 'Logs',
        component: () =>
          import(
            /* webpackChunkName: "administracion" */ '@/modules/Configuracion/views/LogsSistema/LogsSistemaIndex.vue'
          ),
        icon: 'ClockIcon',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Logs',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/auditoria/trazabilidad',
        name: 'TrazabilidadIndex',
        component: () =>
          import(
            /* webpackChunkName: "auditoria" */ '@/modules/Core/views/TrazabilidadView.vue'
          ),
        icon: 'ClipboardDocumentListIcon',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Trazabilidad',
          subTitle: 'Auditoría del flujo clínico',
          requiresSession: true,
          permiso: ['verTrazabilidad'],
          perfiles: ['SUPERADMIN'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/permisos',
        name: 'Permisos',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Autenticacion/Permisos/PermissionIndex.vue'
          ),
        icon: 'mdiCardAccountDetailsStarOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Permisos',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/maestra',
        name: 'Maestra',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Maestra/MaestraIndex.vue'
          ),
        icon: 'TableCellsIcon',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Sistema de listas maestras',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/maestra/view/:id',
        name: 'MaestraTabla',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Maestra/MaestraView.vue'
          ),
        icon: 'TableCellsIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Valores de la tabla maestra',
          requiresSession: true,
          permiso: []
        },
        children: []
      },
      {
        path: '/interoperabilidad',
        name: 'Interoperabilidad',
        component: () =>
          import(
            /* webpackChunkName: "configuracion" */ '@/modules/Configuracion/views/Interoperabilidad/InteroperabilidadIndex.vue'
          ),
        icon: 'mdiLan',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Interoperabilidad',
          requiresSession: true,
          permiso: [],
          perfiles: ['SUPERADMIN'],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/odontograma',
        name: 'Odontograma',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Odontograma/ConvencionesIndex.vue'
          ),
        icon: 'mdiToothOutline',
        typeIcon: 'mdi',
        menu: true,
        desplegable: false,
        meta: {
          title: 'Odontograma',
          requiresSession: true,
          permiso: [],
          perfiles: [],
          showBackButton: false
        },
        children: []
      },
      {
        path: '/convenciones/:id',
        name: 'Convenciones',
        component: () =>
          import(
            /* webpackChunkName: "sistema" */ '@/modules/Configuracion/views/Odontograma/ConvencionesForm.vue'
          ),
        icon: 'QueueListIcon',
        menu: false,
        desplegable: false,
        meta: {
          title: 'Convenciones',
          requiresSession: true,
          permiso: []
        },
        children: []
      }
    ]
  }
]
